import { FormFields } from '@App/forms/v2/common/form-field'
import { FormFieldTypes } from '@App/enum/form-field-types'
import { z } from 'zod'
import { CheckboxSize } from '@App/enum/checkbox-size'
import populateSchema from '@App/forms/v2/helpers/populate-schema'
import { userInfoBaseSchema, userInfoFormFields } from '@Entities/schemas/user/user-info-schema'
import { REQUIRED_MESSAGE } from '@Const/error-messages'

const emailKey = 'email'
const emailLabel = 'Email Address'

const termsAndConditionsKey = 'termsAndConditions'
const privacyPolicyKey = 'privacyPolicy'

const userRegistrationSchema = userInfoBaseSchema.merge(
    z.object({
        [termsAndConditionsKey]: z
            .boolean({
                error: REQUIRED_MESSAGE,
            })
            .refine((val) => val, {
                message: REQUIRED_MESSAGE,
            }),
        [privacyPolicyKey]: z
            .boolean({
                error: REQUIRED_MESSAGE,
            })
            .refine((val) => val, {
                message: REQUIRED_MESSAGE,
            }),
    })
)

type UserRegistrationType = z.infer<typeof userRegistrationSchema>
type UserRegistrationInput = z.input<typeof userRegistrationSchema>

const userRegistrationFormFieldsNoSchema: FormFields<UserRegistrationType> = {
    ...userInfoFormFields,
    [emailKey]: {
        name: emailKey,
        label: emailLabel,
        type: FormFieldTypes.TEXT,
    },
    [termsAndConditionsKey]: {
        name: termsAndConditionsKey,
        label: 'Accept',
        size: CheckboxSize.small,
        checked: true,
        type: FormFieldTypes.CHECKBOX,
    },
    [privacyPolicyKey]: {
        name: privacyPolicyKey,
        label: 'Accept',
        size: CheckboxSize.small,
        checked: true,
        type: FormFieldTypes.CHECKBOX,
    },
}

const userRegistrationFormFields: FormFields<UserRegistrationType> = populateSchema(
    userRegistrationFormFieldsNoSchema,
    userRegistrationSchema
)

export { userRegistrationSchema, UserRegistrationType, UserRegistrationInput, userRegistrationFormFields }
